import React, {useMemo} from "react";
import classnames from "classnames";
import {Fade} from "@mui/material";
import UserPhoneHomepageTagsContainer from "../../../tags-container";
import {formatMoney} from "../../../../../../../../../core/services/utils/utils";
import LazyImage from "../../../../../../../../components/app-specific/lazy-image";

const MediumUserPhoneHomepageProductCard = ({
                                                data,
                                                onClick,
                                                onTagClicked,
                                            }) => {
    const priceNotAvailable = useMemo(() => data?.changedPrice <= 0, [data]);
    const hasNewPrice = useMemo(() => data?.changedPrice < data?.originalPrice, [data]);

    return (
        <>
            <div
                id={data.phoneViewElementId}
                className={classnames('user-phone-homepage-product medium')}
                onClick={onClick}
            >
                <div className={'product-card'}>
                    <div className={'product-header'}>
                        <div className={'product-header-section'}>
                            <p className={'part-no part-number-fluid'}>
                                {data?.partNumber ?? ''}
                            </p>
                            <p className={'category'}>
                                {data?.category?.title ?? data?.category?.Title ?? ''}
                            </p>
                        </div>
                        <div className={'product-header-section'}>
                            {
                                hasNewPrice &&
                                <Fade in={hasNewPrice}>
                                    <p className={'price new'}>
                                        {formatMoney(data?.changedPrice)}
                                    </p>
                                </Fade>
                            }
                            {
                                priceNotAvailable
                                    ? <></>
                                    : <p className={classnames('price', {'old': hasNewPrice})}>
                                        {formatMoney(data?.originalPrice ?? data?.changedPrice)}
                                    </p>
                            }
                        </div>
                    </div>
                    <div className={'product-body'}>
                        <div className={'image'}>
                            <LazyImage
                                src={data?.imageUrl}
                                alt={data?.partNumber}
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                                className={'disable-downloading-image'}
                            />
                        </div>
                    </div>
                </div>
                <UserPhoneHomepageTagsContainer
                    tags={data?.tags}
                    onTagClicked={onTagClicked}
                />
            </div>
        </>
    );
}


export default MediumUserPhoneHomepageProductCard;
